import { createFileRoute } from '@tanstack/react-router'
import LazyRoute from '../components/LazyRoute'
import { TablePageLoader } from '@/components/ui/page-loader'

export const Route = createFileRoute('/_protected/issues')({
  component: () => (
    <LazyRoute
      loader={() => import('@/components/pages/issues/issues')}
      fallback={<TablePageLoader />}
    />
  ),
})
